import { TRANSACTION_BLOCK_TIMEOUT as i } from "../constants/chain.js";
import * as t from "ramda";
import l from "web3";
class m extends l {
  constructor(s, e) {
    !t.isNil(s) && !t.isNil(e) ? super(s, e) : t.isNil(s) ? super() : super(s), this.walletAddress = "", this.isSmartContractWallet = !1, this.eth.transactionBlockTimeout = i;
  }
}
export {
  m as Web3Extended
};
//# sourceMappingURL=web3.js.map
